// export const REDUCER_NAME = "featuredDeal";

// export interface iFeaturedDealDTO {
//   title: string;
//   start_date: string | Date;
//   end_date: string | Date;
//   status?: boolean;
//   productId?: string[];
//   image_url?: string;
// }

// export interface iFeaturedDealResponse {
//   id: string;
//   title: string;
//   start_date: string;
//   end_date: string;
//   status: boolean;
//   image_url?: string;
//   created_at: string;
//   updated_at: string;
//   products?: {
//     id: string;
//     title: string;
//   }[];
// }

// export interface iFeaturedDealState {
//   isLoading: boolean;
//   featuredDealList: iFeaturedDealResponse[];
//   errorMessage: string | null;
//   currentFeaturedDeal: iFeaturedDealResponse | null;
// }

// export interface iMessageResponseType {
//   message: string;
//   id?: string;
// }

// export interface iToggleStatusPayload {
//   dealId: string;
//   status: boolean;
// }



export const REDUCER_NAME = "featuredDealSlice";

export interface iFeaturedDealResponse {
  product_ids: any[];
 product_id: string;
  product_name: string;
  product_image: string;
  product_price: number;
  id: string;
  title: string;
  start_date: string;
  end_date: string;
  status: boolean;
  created_at: string;
  updated_at: string;
  image_url: string;
  active_products: number;
}

export interface iFeaturedDealDTO {
  title: string;
  start_date: string | Date;
  end_date: string | Date;
  status?: boolean;
  image_url?: File | string;
  active_products: number;
  // image?: File | string;
}

export interface iFeaturedDealState {
  dealDetail: iFeaturedDealResponse | null;
  dealList: iFeaturedDealResponse[];
  dealProducts: any[];
  isLoading: boolean;
  errorMessage: string | null;
}